<template>
  <div>
    <div style="margin-top: 40px; display: flex; gap: 30px; align-items: center">
      <el-button size="mini" @click="m__back_to_list">
        <strong><i style="font-weight: bold" class="el-icon-arrow-left"></i> {{ $t('base.back') }}</strong>
      </el-button>
      <strong style="font-size: 18px"> {{ $t('base.create_new_campaign') }} </strong>
    </div>

    <div style="margin-top: 50px">
      <strong style="font-size: 15px">{{ $t('base.basic_settings') }}</strong>

      <div style="display: flex; margin-top: 30px;">
        <div style="width: 150px">
          <span style="font-size: 13px">{{ $t('base.budget') }}</span>
        </div>
        <div style="display: flex; gap: 10px; align-items: center">
          <el-radio v-model="campaign_info.budget_type" label="unlimited">{{ $t('base.unlimited') }}</el-radio>
          <el-radio v-model="campaign_info.budget_type" label="daily_budget">{{ $t('base.daily_budget') }}</el-radio>
          <el-input v-if="campaign_info.budget_type === 'daily_budget'" v-model="campaign_info.daily_budget"
                    type="number" size="mini"></el-input>
        </div>
      </div>

      <div style="display: flex; margin-top: 30px;">
        <div style="width: 150px">
          <span style="font-size: 13px">{{ $t('base.duration') }}</span>
        </div>
        <div style="display: flex; gap: 10px; align-items: center">
          <el-radio v-model="campaign_info.campaign_time" label="unlimited">{{ $t('base.unlimited') }}</el-radio>
          <el-radio v-model="campaign_info.campaign_time" label="daterange">{{
              $t('base.set_start_end_date')
            }}
          </el-radio>
          <el-date-picker
            v-if="campaign_info.campaign_time === 'daterange'"
            v-model="campaign_info.campaign_date_range"
            type="daterange" range-separator="-"
            :start-placeholder="$t('base.start_time')" :end-placeholder="$t('base.end_time')" size="mini"
            format="dd-MM-yyyy">
          </el-date-picker>
        </div>
      </div>

      <div style="display: flex; margin-top: 30px;">
        <div style="width: 150px">
          <span style="font-size: 13px">Vị trí hiển thị</span>
        </div>
        <div style="display: flex; gap: 10px; align-items: center">
          <el-radio v-model="campaign_info.campaign_type" label="all">{{ $t('base.all') }}</el-radio>
          <el-radio v-model="campaign_info.campaign_type" label="search">{{ $t('base.search') }}</el-radio>
          <el-radio v-model="campaign_info.campaign_type" label="targeting">{{ $t('base.discovery') }}</el-radio>
        </div>
      </div>

      <div v-if="create_mode === 'group'" style="display: flex; margin-top: 30px; align-items: center">
        <div style="width: 150px">
          <span style="font-size: 13px">Tên chiến dịch</span>
        </div>
        <div style="display: flex; gap: 10px; align-items: center; width: 300px">
          <el-input v-model="campaign_info.name" size="mini" show-word-limit maxlength="50"></el-input>
        </div>
      </div>
    </div>

    <div style="margin-top: 50px">
      <strong style="font-size: 15px">{{ $t('base.select_products') }}</strong>

      <div style="margin-top: 30px; display: flex">
        <div
          style="width: calc(50% - 20px); border: 1px solid #e5e5e5; border-radius: 8px; padding: 20px; display: flex; cursor: pointer"
          :style="add_product_type === 'manual' ? 'border: 1px solid #ee4d2d' : ''"
          @click="add_product_type = 'manual'">
          <div style="flex: 1; display: flex; flex-direction: column; gap: 10px;">
            <div style="font-size: 14px">{{ $t('base.manually_select_products') }}</div>
            <div style="color: #999; font-size: 13px">
              {{ $t('base.choose_specific_products_message') }}
            </div>
          </div>
          <div style="width: 60px; height: 60px">
            <img
              src="https://deo.shopeemobile.com/shopee/shopee-seller-live-sg/mmf_portal_seller_root_dir/static/modules/pas-product/image/manual-selection.8868149.png"
              alt="" style="width: 100%; height: 100%; object-fit: contain">
          </div>
        </div>
      </div>

      <div style="margin-top: 20px">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="m__show_select_product_dialog">
          {{ $t('base.add_products') }}
        </el-button>
      </div>

      <div style="margin-top: 20px">
        <el-table :data="product_selected_list">
          <el-table-column :label="$t('base.image')" width="50px">
            <template slot-scope="scope">
              <template v-if="scope.row.images.length>0">
                <img :src="SHOPEE_IMAGE(scope.row.images.split(',')[0])" alt="product_logo"
                     style="width:32px; height:32px; border-radius: 4px;"/>
              </template>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.product')" prop="name" show-tooltip-when-overflow>
            <template slot-scope="scope">
              <a href="javascript:void(0)"
                 @click="open_link_fixed(`https://shopee.com/product-i.${shop.shop_id}.${scope.row.id}`, shop)">
                {{ scope.row.name }}
              </a>
              <div>
                <span>
                  {{ $t('base.id') }}: {{ scope.row.id }}
                  &nbsp;&nbsp;
                  {{ $t('base.ratings') }}: {{ scope.row.review_count | currency }}
                </span>
              </div>
              <div v-if="scope.row.ads_list && scope.row.ads_list.length">
                <strong style="color: #ff831d;">{{ $t('base.running_ads') }}</strong>
                &nbsp;
                <a href="javascript:void(0)" style="font-weight: bold" @click="m__open_duplicate_link(scope.row.id)">
                  {{ $t('base.see_detail') }}
                </a>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.price')" prop="price" width="100px" sortable>
            <template slot-scope="scope">
              {{ scope.row.price | currency }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.sold')" prop="sold" width="130px" sortable>
            <template slot-scope="scope">
              {{ scope.row.sold | currency }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.sales')" prop="revenue" width="130px" sortable>
            <template slot-scope="scope">
              {{ scope.row.revenue | currency }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.stock')" prop="stock" width="100px" sortable>
            <template slot-scope="scope">
              {{ scope.row.stock | currency }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.optional')" width="150px" fixed="right">
            <template slot-scope="scope">
              <el-button v-if="product_selected_list.length > 1" type="text" size="mini"
                         @click="m__remove_product(scope.$index)">
                <strong class="text-danger">{{ $t('base.delete') }}</strong>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div v-if="product_selected_list.length && product_selected_list.length > 1" style="margin-top: 40px;">
        <div style="display: flex; align-items: center">
          <strong style="font-size: 14px">
            Phương thức quảng bá
          </strong>
        </div>

        <div style="margin-top: 20px; display: flex; flex-direction: column; gap: 10px">
          <el-radio v-model="create_mode" label="single">
            <span style="font-size: 13px">Tạo chiến dịch riêng cho từng sản phẩm</span>
          </el-radio>
          <el-radio v-model="create_mode" label="group">
            <span style="font-size: 13px">Tạo chiến nhóm cho tất cả các sản phẩm đã chọn</span>
          </el-radio>
        </div>
      </div>
    </div>

    <div style="margin-top: 50px">
      <strong style="font-size: 15px">{{ $t('base.bidding') }}</strong>

      <div style="margin-top: 30px; display: flex; gap: 20px">
        <div
          style="flex: 1; border: 1px solid #e5e5e5; border-radius: 8px; padding: 20px; display: flex; gap: 10px; cursor: pointer"
          :style="config_campaign_price_type === 'auto' ? 'border: 1px solid #ee4d2d' : ''"
          @click="config_campaign_price_type = 'auto'">
          <div style="flex: 1; display: flex; flex-direction: column; gap: 10px;">
            <div style="font-size: 14px">{{ $t('create_ads.auto_bidding') }}</div>
            <div style="color: #999; font-size: 13px">
              {{ $t('base.let_shopee_do') }}
            </div>
          </div>
          <div style="width: 60px; height: 60px">
            <img
              src="https://deo.shopeemobile.com/shopee/shopee-seller-live-sg/mmf_portal_seller_root_dir/static/modules/pas-product/image/auto-bidding.36bfe76.png"
              alt="" style="width: 100%; height: 100%; object-fit: contain">
          </div>
        </div>

        <div
          style="flex: 1; border: 1px solid #e5e5e5; border-radius: 8px; padding: 20px; display: flex; gap: 10px; cursor: pointer"
          :style="config_campaign_price_type === 'manual' ? 'border: 1px solid #ee4d2d' : ''"
          @click="config_campaign_price_type = 'manual'">
          <div style="flex: 1; display: flex; flex-direction: column; gap: 10px;">
            <div style="font-size: 14px">{{ $t('create_ads.manual_bidding') }}</div>
            <div style="color: #999; font-size: 13px">
              {{ $t('base.bidding_settings_manually') }}
            </div>
          </div>
          <div style="width: 60px; height: 60px">
            <img
              src="https://deo.shopeemobile.com/shopee/shopee-seller-live-sg/mmf_portal_seller_root_dir/static/modules/pas-product/image/manual-bidding.3c54192.png"
              alt="" style="width: 100%; height: 100%; object-fit: contain">
          </div>
        </div>
      </div>
    </div>

    <template v-if="config_campaign_price_type === 'auto'">
      <!-- todo: roi1 -->
      <div
        v-if="false && non_ads_data && non_ads_data.ext_toggle && non_ads_data.ext_toggle.sz_ads_product_target_broad_roas"
        style="margin-top: 50px">
        <strong class="text-danger" style="font-size: 15px">*</strong>
        <strong style="font-size: 15px">
          {{ $t('base.target_roas') }}
        </strong>

        <div style="margin-top: 30px">
          <div>
            <el-radio v-model="form_update_target_broad_roi.type" :label="'auto'">
              {{ $t('create_ads.auto_bidding') }}
            </el-radio>
            <div>
              {{ $t('create_ads.auto_bidding_message') }}
            </div>
          </div>
          <div
            style="margin-top: 20px">
            <el-radio v-model="form_update_target_broad_roi.type" :label="'custom'">
              {{ $t('create_ads.manual_bidding') }}
            </el-radio>
            <div>
              {{ $t('base.set_your_own_roas') }}
            </div>
          </div>
          <div v-if="form_update_target_broad_roi.type === 'custom'"
               style="margin-top: 20px; padding-left: 10px; display: flex; flex-direction: column; gap: 10px">
            <div v-for="item in form_update_target_broad_roi.custom_type_list" :key="item" style="display: flex">
              <div style="width: 150px">
                <el-radio v-model="form_update_target_broad_roi.custom_type" :label="item">
                  ROAS = {{ item / 100000 }}
                </el-radio>
              </div>
              <div>

              </div>
            </div>
            <div style="display: flex">
              <div style="width: 150px">
                <el-radio v-model="form_update_target_broad_roi.custom_type" :label="'custom'">
                  {{ $t('create_ads.custom') }}
                </el-radio>
              </div>
              <div style="flex: 1; padding-right: 10px">
                <el-input type="number" v-model="form_update_target_broad_roi.custom_value" :min="1" :max="50"
                          size="mini" placeholder="1.0 ~ 50.0" style="width: 300px">
                </el-input>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--      <pre>{{ non_ads_data }}</pre>-->

      <!-- todo: roi2 -->
      <div v-if="non_ads_data && non_ads_data.ext_toggle && non_ads_data.ext_toggle.sz_ads_roi2"
           style="margin-top: 50px">
        <template v-if="!ads_data.ads_toggle.enable_simple_ads_roi2">
          <el-checkbox v-model="enable_roi_two">
            {{ $t('ads.enable_target_roas') }}
          </el-checkbox>
          <div style="padding-left: 30px">
            {{ $t('ads.maximise_gmv_potential_by') }}
          </div>
        </template>

        <div v-if="enable_roi_two" style="margin-top: 30px; padding-left: 30px">
          <template v-if="ads_data.ads_toggle.enable_simple_ads_roi2">
            <div>
              <el-radio v-model="form_update_target_broad_roi.custom_type" :label="0">
                {{ $t('ads.gmv_max_auto_title') }}
              </el-radio>
            </div>
          </template>

          <div style="margin-top: 30px">{{ $t('ads.gmv_max_custom_title') }}</div>
          <div style="display: flex; flex-direction: column; gap: 25px; margin-top: 15px">
            <div v-for="item of roi_two_list" style="display: flex;">
              <el-radio v-model="form_update_target_broad_roi.custom_type" :label="item.value" style="width: 150px">
                ROAS = {{ item.value }}
              </el-radio>

              <span>
                {{ $t('ads.better_competitiveness_than_x', {x: item.percent}) }}
              </span>
            </div>
            <div style="display: flex; align-items: center; gap: 20px">
              <div style="width: 160px">
                <el-radio v-model="form_update_target_broad_roi.custom_type" :label="'custom'">
                  {{ $t('create_ads.custom') }}
                </el-radio>
              </div>
              <div style="flex: 1; padding-right: 10px">
                <el-input type="number" v-model="form_update_target_broad_roi.custom_value" :min="1" :max="50"
                          size="mini" placeholder="1.0 ~ 50.0" style="width: 300px"
                          :disabled="form_update_target_broad_roi.custom_type !== 'custom'">
                </el-input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="['all', 'search'].includes(campaign_info.campaign_type) && config_campaign_price_type === 'manual'">
      <div style="margin-top: 50px">
        <strong class="text-danger" style="font-size: 15px">*</strong>
        <strong style="font-size: 15px">
          {{ $t('ads.add_keywords') }}
        </strong>

        <div>
          <el-row style="margin-top: 10px">
            <el-col :sm="15" style="padding-right: 20px">
              <p class="text-title">{{ $t('base.keyword_selection') }}</p>
              <br>
              <div style="height: 50px; margin: 15px 0 0 0;">
                <div class="atosa-tab">
                  <div class="atosa-tab-item" :class="radio === '1' ? 'atosa-tab-item-active': ''" @click="radio = '1'">
                    {{ $t('base.shopee_recommend') }}
                  </div>
                  <div v-if="m__check_marketing_package('keyword_tool')"
                       class="atosa-tab-item" :class="radio === '4' ? 'atosa-tab-item-active': ''" @click="radio = '4'">
                    {{ $t('menu.atosa_keyword_tool') }}
                  </div>
                  <div class="atosa-tab-item" :class="radio === '2' ? 'atosa-tab-item-active': ''" @click="radio = '2'">
                    {{ $t('keyword.file') }} (Atosa)
                  </div>
                  <div class="atosa-tab-item" :class="radio === '3' ? 'atosa-tab-item-active': ''" @click="radio = '3'">
                    {{ $t('base.search_keywords') }}
                  </div>
                  <div class="atosa-tab-item" :class="radio === '5' ? 'atosa-tab-item-active': ''" @click="radio = '5'">
                    Import Excel
                  </div>
                  <br>
                </div>
              </div>

              <template v-if="radio === '1'">
                <div style="height: 24px; margin-top: 10px">
                </div>
                <el-table :data="c__shopee_keyword_display_list"
                          @sort-change="({prop, order}) => {shopee_filter.sort_option.order = order; shopee_filter.sort_option.prop = prop}">
                  <el-table-column
                    :label="$t('base.keyword')"
                    prop="keyword">
                  </el-table-column>
                  <el-table-column
                    :label="$t('base.volume')"
                    prop="search_volume"
                    sortable="custom">
                    <template slot-scope="scope">{{ scope.row.search_volume | currency }}</template>
                  </el-table-column>
                  <el-table-column :label="$t('base.relevance')" prop="relevance" sortable="custom">
                    <template slot-scope="scope">{{ scope.row.relevance | currency }}/10</template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('base.recommend_price')" prop="recommend_price" sortable="custom">
                    <template slot-scope="scope">
                      <el-input size="mini" v-model="scope.row.recommend_price" type="number"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('base.action')"
                    align="right"
                    width="90px">
                    <template slot-scope="scope">
                      <div style="padding-top: 5px">
                        <strong v-if="m__can_add(scope.row)" href="javascript:void(0)" type="text" class="text-info"
                                @click="m__add_keyword(scope.row, 'shopee_suggest_keywords')">
                          <strong>{{ $t('base.add') }} ></strong></strong>
                        <strong v-else href="javascript:void(0)" class="text-grey">{{ $t('base.added') }}</strong>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination :current-page.sync="shopee_filter.current_page" :page-size="shopee_filter.page_size"
                               layout="prev, pager, next, total" :total="shopee_suggest_keywords.length"/>
              </template>

              <template v-if="radio === '2'">
                <div style="height: 35px;">
                  <el-row>
                    <el-col :sm="12">
                      <el-select size="mini" value="" v-model="selected_keyword_file"
                                 @change="m__get_keyword_file_detail"
                                 filterable :placeholder="$t('select.keyword_file')" style="width: 250px">
                        <el-option v-for="keyword in keyword_file_list" :key="keyword._id" :value="keyword._id"
                                   :label="keyword.filename"></el-option>
                      </el-select>
                      &nbsp;&nbsp;
                      <strong><a href="javascript:void(0)" style="color: orangered"
                                 @click="m__get_keyword_file">({{ $t('base.update') }})</a></strong>
                    </el-col>
                    <el-col :sm="12" class="text-right">
                      <el-select v-model="form_add_new_campaign.price_type" size="mini"
                                 style="border: none !important; width: 230px">
                        <el-option :value="'mipee'" :label="$t('base.use_saved_bid_price')"></el-option>
                        <el-option :value="'shopee'" :label="$t('base.use_shopee_bid_price')"></el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                </div>
                <el-table :data="c__mipee_keywords_display_list"
                          @sort-change="({prop, order}) => {mipee_filter.sort_option.order = order; mipee_filter.sort_option.prop = prop}">
                  <el-table-column :label="$t('base.keyword')" prop="keyword">
                    <template slot-scope="scope">{{ scope.row.keyword.normalize() }}</template>
                  </el-table-column>
                  <el-table-column :label="$t('base.volume')" prop="search_volume" sortable="custom">
                    <template slot-scope="scope">{{ scope.row.search_volume | currency }}</template>
                  </el-table-column>
                  <el-table-column :label="$t('base.saved_bid_price')" prop="price" sortable="custom">
                    <template slot-scope="scope" slot="header">
                      {{ $t('base.saved_bid_price') }} <span v-if="form_add_new_campaign.price_type === 'mipee'"
                                                             style="color: red">*</span>
                    </template>
                    <template slot-scope="scope">
                      <el-input size="mini" type="number" :min="400" v-model="scope.row.price"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('base.shopee_bid_price')" prop="recommend_price" sortable="custom">
                    <template slot-scope="scope" slot="header">
                      {{ $t('base.shopee_bid_price') }} <span v-if="form_add_new_campaign.price_type === 'shopee'"
                                                              style="color: red">*</span>
                    </template>
                    <template slot-scope="scope">
                      <el-input size="mini" type="number" :min="400" v-model="scope.row.recommend_price"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('base.action')" width="90px" align="right">
                    <template slot-scope="scope">
                      <strong v-if="m__can_add(scope.row)" href="javascript:void(0)" @click="m__add_keyword(scope.row)"
                              class="text-info">{{ $t('base.add') }} ></strong>
                      <strong v-else href="javascript:void(0)">{{ $t('base.added') }}</strong>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination :current-page.sync="mipee_filter.current_page" :page-size="mipee_filter.page_size"
                               layout="prev, pager, next, total" :total="mipee_suggest_keywords.length"/>
                <br>
              </template>

              <template v-if="radio === '3'">
                <div style="height: 35px;">
                  <el-autocomplete size="mini" :placeholder="$t('input.placeholder')" v-model="keyword"
                                   style="width: 250px" :fetch-suggestions="m__suggest_keyword"
                                   @select="m__search_sp_keyword"></el-autocomplete>
                </div>
                <el-table :data="c__search_keyword_display_list"
                          @sort-change="({prop, order}) => {search_keyword_filter.sort_option.order = order; search_keyword_filter.sort_option.prop = prop}">
                  <el-table-column :label="$t('base.keyword')" prop="keyword">
                    <template slot-scope="scope">{{ scope.row.keyword.normalize() }}</template>
                  </el-table-column>
                  <el-table-column :label="$t('base.volume')" prop="sp_volume" sortable="custom">
                    <template slot-scope="scope">{{ scope.row.sp_volume | currency }}</template>
                  </el-table-column>
                  <el-table-column :label="$t('base.relevance')" prop="relevance" sortable="custom">
                    <template slot-scope="scope">{{ scope.row.relevance | currency }}/10</template>
                  </el-table-column>
                  <el-table-column :label="$t('base.recommend_price')" prop="sp_price" sortable="custom">
                    <template slot-scope="scope">{{ scope.row.sp_price | currency }}</template>
                  </el-table-column>
                  <el-table-column :label="$t('base.action')" width="90px" align="right">
                    <template slot-scope="scope">
                      <strong v-if="m__can_add(scope.row)" href="javascript:void(0)" @click="m__add_keyword(scope.row)"
                              class="text-info">{{ $t('base.add') }} ></strong>
                      <strong v-else href="javascript:void(0)">{{ $t('base.added') }}</strong>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination :current-page.sync="search_keyword_filter.current_page"
                               :page-size="search_keyword_filter.page_size"
                               layout="prev, pager, next, total" :total="search_keyword.length"/>
              </template>

              <template v-if="radio === '4'">
                <div style="height: 35px; margin-top: 9px">
                  <el-input size="mini" :placeholder="$t('input.placeholder')"
                            v-model="base_keyword" style="width: 250px" @keyup.enter.native="m__enter_input"></el-input>
                  <el-button size="mini" type="primary" icon="el-icon-search" :loading="fff_loading"
                             @click="m__try_get_keyword_result"> {{ $t('base.search') }}
                  </el-button>
                </div>
                <el-table :data="c__fff_result_display_list" @sort-change="m__fff_sort_change" class="fff-table">
                  <el-table-column :label="$t('base.keyword')" show-tooltip-when-overflow>
                    <template slot-scope="scope">
                      {{ scope.row.keyword.normalize() }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="sp_volume"
                    :label="$t('base.volume')" sortable="custom">
                    <template slot-scope="scope">
                      {{ scope.row.sp_volume | currency }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="sp_price"
                    :label="$t('base.recommend_price')" sortable="custom">
                    <template slot-scope="scope">
                      {{ scope.row.sp_price | currency }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('base.action')"
                    align="right" width="90px">
                    <template slot-scope="scope">
                      <div style="padding-top: 5px">
                        <strong v-if="m__can_add(scope.row)" href="javascript:void(0)" type="text" class="text-info"
                                @click="m__add_keyword(scope.row, 'shopee_suggest_keywords')">
                          <strong>{{ $t('base.add') }} ></strong></strong>
                        <strong v-else href="javascript:void(0)" class="text-grey">{{ $t('base.added') }}</strong>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination :current-page.sync="atosa_keyword_filter.current_page"
                               :page-size="atosa_keyword_filter.page_size"
                               layout="prev, pager, next, total" :total="fff_result.length"/>
              </template>

              <el-row v-if="radio === '5'">
                <div style="height: 35px;">
                  <el-button size="mini" type="primary" icon="ti-harddrives" @click="m__show_import_excel_file">
                    &nbsp;&nbsp;&nbsp;{{ $t('base.import_excel_file') }}
                  </el-button>
                  &nbsp;&nbsp;&nbsp;<strong class="text-danger">*{{ $t('keyword.import_note') }}</strong>
                </div>
                <el-table
                  :data="c__excel_keyword_display_list">
                  <el-table-column
                    :label="$t('base.keyword')">
                    <template slot-scope="scope">
                      {{ scope.row.keyword.normalize() }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="search_volume"
                    :label="$t('base.volume')" sortable>
                    <template slot-scope="scope">
                      {{ scope.row.search_volume | currency }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="recommend_price"
                    :label="$t('base.recommend_price')" sortable>
                    <template slot-scope="scope">
                      {{ scope.row.recommend_price | currency }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('base.action')" width="90px"
                    align="right">
                    <template slot-scope="scope">
                      <div style="padding-top: 5px">
                        <a v-if="m__can_add(scope.row)" href="javascript:void(0)" type="text"
                           @click="m__add_keyword(scope.row, 'shopee_suggest_keywords')">
                          <strong>{{ $t('base.add') }} ></strong></a>
                        <a v-else href="javascript:void(0)" class="text-grey">{{ $t('base.added') }}</a>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination :current-page.sync="excel_keyword_filter.current_page"
                               :page-size="excel_keyword_filter.page_size"
                               layout="prev, pager, next, total" :total="excel_keyword.length"/>
              </el-row>

              <br>
              <el-button size="mini" type="primary" @click="m__add_all">
                {{ radio !== '4' ? $t('keyword.add_all') : $t('keyword.add_top_x', {x: '100'}) }}
              </el-button>
              &nbsp;
              &nbsp;
              &nbsp;
              <el-checkbox v-model="omit_duplicated_keyword">{{ $t('base.remove_duplicated_keywords') }}</el-checkbox>
            </el-col>

            <el-col :sm="9" style="padding-left: 20px">
              <p class="text-title"> {{ $t('keyword.added_keywords') }}</p>
              <br>

              <div style="height: 50px; margin: 15px 0 10px 0;">
                <el-row>
                  <el-col :sm="24">
                    <el-select v-model="form_add_new_campaign.match_type" size="mini" style="border: none !important;">
                      <el-option :value="0" :label="$t('keyword.exact')"></el-option>
                      <el-option :value="1" :label="$t('keyword.broad')"></el-option>
                    </el-select>
                    &nbsp;
                    <el-button size="mini" @click="m__show_update_keyword_dialog"> {{
                        $t('base.edit_bid_price')
                      }}
                    </el-button>
                    <el-button size="mini" type="info" @click="added_keyword = []">Clear</el-button>
                  </el-col>
                </el-row>
              </div>

              <div style="height: 35px; margin-top: 10px">
              </div>

              <el-table :data="c__added_keyword_display_list">
                <el-table-column
                  :label="$t('base.keyword')"
                  prop="keyword"
                  show-tooltip-when-overflow>
                </el-table-column>
                <el-table-column width="120px" :label="$t('base.bid_price')">
                  <template slot-scope="scope">
                    <el-input size="mini" v-model="scope.row.recommend_price" type="number"></el-input>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('base.action')" align="right" width="90px">
                  <template slot-scope="scope">
                    <div style="padding-top: 5px">
                      <a href="javascript:void(0)" type="text" class="text-danger"
                         @click="m__remove_keyword(scope.row)">
                        <strong> {{ $t('base.delete') }}</strong></a>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination :current-page.sync="added_keyword_filter.current_page"
                             :page-size="added_keyword_filter.page_size"
                             layout="prev, pager, next, total" :total="added_keyword.length"/>

              <div class="text-right" style="margin-top: 10px">
                <el-button size="mini" type="primary" icon="ti-save"
                           @click="m__initial_save_keyword_file">{{ $t('keyword.save_file') }}
                </el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </template>
    <template
      v-if="['all', 'targeting'].includes(campaign_info.campaign_type) && config_campaign_price_type === 'manual'">
      <div style="margin-top: 50px">
        <strong class="text-danger" style="font-size: 15px">*</strong>
        <strong style="font-size: 15px">
          {{ $t('base.discovery_locations') }}
        </strong>

        <div style="margin-top: 30px">
          <el-table :data="advertisements">
            <el-table-column :label="$t('base.placement')" width="200px">
              <template slot-scope="scope">
                <template v-if="scope.row.placement === 2">
                  {{ $t('base.daily_discover') }}
                </template>
                <template v-if="scope.row.placement === 5">
                  {{ $t('base.you_may_also_like') }}
                </template>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.status')">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.status"
                  active-color="#13ce66"
                  inactive-color="#b7b7b7"
                  :active-value="1"
                  :inactive-value="3"
                  :disabled="scope.row.status === 1 && advertisements.filter(i => i.status === 1).length <= 1">
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.bid_price')" width="300px">
              <template slot-scope="scope">
                <el-input type="number" v-model="scope.row.extinfo.target.price" size="mini"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </template>

    <template
      v-if="config_campaign_price_type === 'manual' && non_ads_data && non_ads_data.ext_toggle && non_ads_data.ext_toggle.sz_ads_product_target_audience">
      <div style="margin-top: 50px">
        <strong style="font-size: 15px">{{ $t('base.audience_targeting') }}</strong>

        <div style="margin-top: 30px; display: flex; gap: 20px">
          <div
            style="flex: 1; border: 1px solid #e5e5e5; border-radius: 8px; padding: 20px; display: flex; flex-direction: column; gap: 10px; cursor: pointer"
            :style="target_audience_type === 'auto' ? 'border: 1px solid #ee4d2d' : ''"
            @click="target_audience_type = 'auto'">
            <div style="font-size: 14px">{{ $t('base.auto_targeting') }}</div>
            <div style="color: #999; font-size: 13px">
              {{ $t('create_ads.let_shopee_audience') }}
            </div>
          </div>

          <div
            style="flex: 1; border: 1px solid #e5e5e5; border-radius: 8px; padding: 20px; display: flex; flex-direction: column; gap: 10px; cursor: pointer"
            :style="target_audience_type === 'manual' ? 'border: 1px solid #ee4d2d' : ''"
            @click="target_audience_type = 'manual'">
            <div style="font-size: 14px">{{ $t('base.manual_targeting') }}</div>
            <div style="color: #999; font-size: 13px">
              {{ $t('create_ads.prioritise_specific') }}
            </div>
          </div>
        </div>
      </div>

      <el-table v-if="target_audience_type === 'manual'" :data="target_audience_list" style="margin-top: 30px">
        <el-table-column :label="$t('base.custom_audience')" min-width="330px">
          <template slot-scope="scope">
            <div style="padding-right: 10px; display: flex; flex-direction: column; gap: 5px">
              <div>
                <span style="font-size: 13px">{{ scope.row.group_name }}</span>
              </div>
              <div>
                <span style="font-size: 12px">{{ $t('base.age') }}:</span>
                <span style="font-size: 12px">
                  {{ m__map_audience_tag_name(scope.row, 'age') }}
                </span>
              </div>
              <div>
                <span style="font-size: 12px">{{ $t('base.gender') }}:</span>
                <span style="font-size: 12px">
                  {{ m__map_audience_tag_name(scope.row, 'gender') }}
                </span>
              </div>
              <div>
                <span style="font-size: 12px">{{ $t('base.buyer_type') }}:</span>
                <span style="font-size: 12px">
                  {{ m__map_audience_tag_name(scope.row, 'buyer') }}
                </span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('base.premium_rate')" width="200px" fixed="right">
          <template slot-scope="scope">
            <el-input v-model="scope.row.premium_rate" size="mini" type="number"></el-input>
          </template>
        </el-table-column>
        <el-table-column :label="$t('base.action')" width="120px" fixed="right">
          <template slot-scope="scope">
            <div style="display: flex; flex-direction: column; gap: 5px">
              <el-button type="text" size="mini" @click="m__show_update_target_audience_dialog(scope.row)">
                <strong class="text-primary">{{ $t('base.edit') }}</strong>
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <template v-if="config_campaign_price_type === 'manual'">
      <div style="margin-top: 50px">
        <strong style="font-size: 15px">
          {{ $t('base.advanced_settings') }}
        </strong>
      </div>

      <div style="margin-top: 20px; display: flex; align-items: center">
        <el-switch
          v-model="ecpc"
          active-color="#13ce66"
          inactive-color="#b7b7b7"
          :active-value="true"
          :inactive-value="false">
        </el-switch>
        <div style="margin-left: 15px; font-size: 14px; padding-top: 2px">
          {{ $t('base.enhanced_bid_price') }}
        </div>
      </div>
      <div style="margin-top: 12px; width: 70%; color: #999; font-size: 12px; line-height: 20px">
        {{ $t('ads.ecpc_shopee_message') }}
      </div>

      <div v-if="campaign_info.campaign_type === 'all'" style="margin-top: 20px; display: flex; align-items: center">
        <el-switch
          v-model="create_separate_ads"
          active-color="#13ce66"
          inactive-color="#b7b7b7"
          :active-value="true"
          :inactive-value="false">
        </el-switch>
        <div style="margin-left: 15px; font-size: 14px; padding-top: 2px">
          {{ $t('ads.create_separate_ads') }}
        </div>
      </div>
      <div style="margin-top: 12px; width: 70%; color: #999; font-size: 12px; line-height: 20px">
        {{ $t('ads.create_separate_ads_message') }}
      </div>
    </template>

    <div style="margin: 50px 0" class="text-right">
      <el-button type="primary" size="medium" :loading="loading.create_campaign" icon="el-icon-check"
                 @click="m__confirm_create_new_product_campaign">{{ $t('base.create_new_campaign') }}
      </el-button>
    </div>

    <el-dialog :visible.sync="show_dialog.select_product" :close-on-click-modal="false"
               width="1150px">
      <div slot="title" style="padding: 0 10px 10px 10px">
        <strong style="font-size: 18px">
          {{ $t('ads.select_products_for_creating_ad') }}
          <span v-if="!get_products" class="text-primary" style="font-size: 14px; cursor: pointer"
                @click="$emit('reload_products')">
            ({{ $t('base.update_data') }})
          </span>
          <span v-else class="text-warning" style="font-size: 14px">
            (<i class="el-icon-loading"></i> {{ $t('base.loading_data') }}...)
          </span>
        </strong>
        <br>
        <br>

        <el-row style="margin-top: 10px">
          <el-col :sm="9" style="font-size: 14px">
            {{ $t('product.list') }} ({{ $t('base.selected') }} {{ product_list.filter(i => i.checked).length }})
          </el-col>
          <el-col :sm="5" style="padding-left: 10px">
            <el-cascader
              size="mini"
              v-model="cascader_value"
              class="full-w"
              :options="cascader_options"
              :props="{ expandTrigger: 'hover' }"
              :placeholder="$t('select.category')"
              clearable @change="m__on_cascader_change"></el-cascader>
          </el-col>
          <el-col :sm="5" style="padding-left: 5px">
            <el-select v-model="product_filter.filter_type" size="mini" value class="full-w">
              <el-option value="all" :label="$t('base.all_products')"></el-option>
              <el-option value="ads_list_null"
                         :label="$t('base.not_creating_ads')"></el-option>
              <el-option value="not_creating_roi_two_ads"
                         :label="$t('ads.not_creating_roi_two_ads')"></el-option>
              <!--              <el-option value="not_creating_all_ads_auto"
                                       :label="$t('ads.not_creating_all_ads_auto')"></el-option>-->
              <el-option value="not_creating_all_ads_manual"
                         :label="$t('ads.not_creating_all_ads_manual')"></el-option>
              <!--              <el-option value="not_creating_search_ads_auto"
                                       :label="$t('ads.not_creating_search_ads_auto')"></el-option>-->
              <el-option value="not_creating_search_ads_manual"
                         :label="$t('ads.not_creating_search_ads_manual')"></el-option>
              <!--              <el-option value="not_creating_discover_ads_auto"
                                       :label="$t('ads.not_creating_discover_ads_auto')"></el-option>-->
              <el-option value="not_creating_discover_ads_manual"
                         :label="$t('ads.not_creating_discover_ads_manual')"></el-option>
            </el-select>
          </el-col>
          <el-col :sm="5" style="padding-left: 10px">
            <el-input size="mini" v-model="product_filter.keyword" :placeholder="$t('input.placeholder')"></el-input>
          </el-col>
        </el-row>

        <br>
        <el-table :data="c__product_display_list" @sort-change="m__product_sort_change"
                  v-loading="loading.get_products">
          <el-table-column label="#" width="40px">
            <template slot="header" slot-scope="scope">
              <el-checkbox size="mini" :value="c__product_display_list.every(i => i.checked)"
                           @change="(e) => c__product_display_list.forEach(i => i.checked = e)"></el-checkbox>
            </template>
            <template slot-scope="scope">
              <el-checkbox size="mini" v-model="scope.row.checked"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.image')" width="50px">
            <template slot-scope="scope">
              <template v-if="scope.row.images.length>0">
                <img :src="SHOPEE_IMAGE(scope.row.images.split(',')[0])" alt="product_logo"
                     style="width:32px; height:32px; border-radius: 4px;"/>
              </template>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.product')" prop="name" show-tooltip-when-overflow width="380px">
            <template slot-scope="scope">
              <a href="javascript:void(0)"
                 @click="open_link_fixed(`https://shopee.com/product-i.${shop.shop_id}.${scope.row.id}`, shop)">
                {{ scope.row.name }}
              </a>
              <div>
                <span>
                  {{ $t('product.id') }}: {{ scope.row.id }}
                  <template>
                    &nbsp;
                    {{ $t('base.rating') }}: {{ scope.row.extra_data.rating }}
                  </template>
                  <!--                  &nbsp;&nbsp;-->
                  <!--                  {{ $t('base.ratings') }}: {{ scope.row.review_count | currency }}-->
                </span>
              </div>
              <div style="height: 25px">
                <div v-if="scope.row.ads_list && scope.row.ads_list.length">
                  <strong style="color: #ff831d;">{{ $t('base.running_ads') }}</strong>
                  &nbsp;
                  <a href="javascript:void(0)" style="font-weight: bold" @click="m__open_duplicate_link(scope.row.id)">
                    {{ $t('base.see_detail') }}
                  </a>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.price')" prop="price" width="100px" sortable="custom">
            <template slot-scope="scope">
              {{ scope.row.price | currency }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.sold')" prop="sold" width="130px" sortable="custom">
            <template slot-scope="scope">
              {{ scope.row.sold | currency }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('center.add_to_cart_units_30_days')" prop="extra_data.add_to_cart_units"
                           width="130px" sortable="custom">
            <template slot-scope="scope">
              {{ scope.row.extra_data.add_to_cart_units | currency }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('center.items_sold_30_days')" prop="extra_data.orders" sortable="custom"
                           width="130px">
            <template slot-scope="scope">
              {{ scope.row.extra_data.orders | currency }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('center.sales_30_days')" prop="extra_data.sales" sortable="custom" width="130px">
            <template slot-scope="scope">
              {{ scope.row.extra_data.sales | currency }}
            </template>
          </el-table-column>
          <!--         <el-table-column :label="$t('base.sales')" prop="revenue" width="130px" sortable="custom">
                      <template slot-scope="scope">
                        {{ scope.row.revenue | currency }}
                      </template>
                    </el-table-column>-->
          <el-table-column :label="$t('base.stock')" prop="stock" width="100px" sortable="custom">
            <template slot-scope="scope">
              {{ scope.row.stock | currency }}
            </template>
          </el-table-column>
        </el-table>
        <br>
        <el-row>
          <el-col :sm="12">
            <el-pagination :current-page.sync="product_filter.current_page" :page-size="product_filter.page_size"
                           layout="prev, pager, next, total" :total="c__product_filter_list.length"/>
          </el-col>
          <el-col :sm="12" class="text-right">
            <el-button size="mini" type="primary" @click="m__confirm_select_product" icon="el-icon-check">
              {{ $t('base.confirm') }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.shopee_result" :close-on-click-modal="false" custom-class="no-body"
               width="700px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('ads.create_campaigns_result') }}</strong>

        <div>
          <el-table :data="create_campaigns_result">
            <el-table-column :label="$t('base.product')" show-tooltip-when-overflow>
              <template slot-scope="scope">{{ scope.row.name }}</template>
            </el-table-column>
            <el-table-column :label="$t('base.status')">
              <template slot-scope="scope">
                <div v-if="scope.row.code === 0">
                  <strong class="text-success">{{ $t('base.create_campaign_success') }}</strong>
                </div>
                <div v-else>
                  <strong class="text-danger">{{ $t('ads.cannot_create_campaign') }}</strong>
                  <br>
                  <strong class="text-danger">
                    {{ $t('base.error_code') }}: {{ scope.row.code }} - {{ scope.row.message }}
                  </strong>
                  <br>
                  <div v-for="item in scope.row.validation_error_list">
                    <strong>field: {{ item.field }} - msg: {{ item.msg }}</strong>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div style="margin-top: 30px" class="text-right">
          <el-button
            v-if="create_campaigns_result.filter(i => i.code === 0).length === create_campaigns_result.length"
            size="mini" type="primary" @click="show_dialog.shopee_result = false; m__back_to_list()">
            {{ $t('ads.back_to_campaigns') }}
          </el-button>
          <el-button size="mini" type="default" icon="el-icon-close" @click="show_dialog.shopee_result = false">
            {{ $t('base.close') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.update_keyword_price" :close-on-click-modal="false"
               width="800px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title"> {{ $t('base.mass_edit_x', {x: $t('base.bid_price')}) }} </strong>

        <el-row>
          <el-col :sm="12">
            <el-radio v-model="form_update_multiple_keyword_price.update_type" :label="1">
              {{ $t('base.i_or_d_x_by_amount', {x: $t('base.bid_price')}) }}
            </el-radio>
          </el-col>
          <el-col :sm="12">
            <el-row>
              <el-col :sm="12">
                <el-select size="mini" v-model="form_update_multiple_keyword_price.update_by_cost" class="full-w"
                           :disabled="form_update_multiple_keyword_price.update_type !== 1">
                  <el-option value="increase" :label="$t('base.increase')"></el-option>
                  <el-option value="reduce" :label="$t('base.decrease')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="12">
                <el-input size="mini" type="number" :disabled="form_update_multiple_keyword_price.update_type !== 1"
                          v-model="form_update_multiple_keyword_price.update_by_cost_value"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="margin-top: 10px">
          <el-col :sm="12">
            <el-radio v-model="form_update_multiple_keyword_price.update_type" :label="2">
              {{ $t('base.i_or_d_x_by_percent', {x: $t('base.bid_price')}) }}
            </el-radio>
          </el-col>
          <el-col :sm="12">
            <el-row>
              <el-col :sm="12">
                <el-select size="mini" v-model="form_update_multiple_keyword_price.update_by_percent" class="full-w"
                           :disabled="form_update_multiple_keyword_price.update_type !== 2">
                  <el-option value="increase" :label="$t('base.increase')"></el-option>
                  <el-option value="reduce" :label="$t('base.decrease')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="12">
                <el-input size="mini" type="number" :disabled="form_update_multiple_keyword_price.update_type !== 2"
                          v-model="form_update_multiple_keyword_price.update_by_percent_value"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="margin-top: 10px">
          <el-col :sm="12">
            <el-radio v-model="form_update_multiple_keyword_price.update_type" :label="3">
              {{ $t('base.set_x', {x: $t('base.bid_price')}) }}
            </el-radio>
          </el-col>
          <el-col :sm="12">
            <el-row>
              <el-col :sm="12">
                &nbsp;
              </el-col>
              <el-col :sm="12">
                <el-input size="mini" type="number" :disabled="form_update_multiple_keyword_price.update_type !== 3"
                          v-model="form_update_multiple_keyword_price.price"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <div style="margin-top: 10px" class="text-right">
          <el-button size="mini" type="primary" icon="el-icon-check" @click="m__update_keyword_price">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.update_target_audience" :close-on-click-modal="false"
               width="600px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.edit_audience') }}</strong>

        <div style="display: flex; flex-direction: column; gap: 20px">
          <div style="display: flex">
            <div style="width: 140px">{{ $t('base.audience_name') }}</div>
            <div style="flex: 1">
              <el-input size="mini" v-model="target_audience_form.group_name"></el-input>
            </div>
          </div>
          <div style="display: flex">
            <div style="width: 140px">{{ $t('base.age') }}</div>
            <div style="flex: 1; display: flex; gap: 5px">
              <el-checkbox-group v-model="target_audience_form.age">
                <el-checkbox label="all"
                             @click.native="target_audience_form.age = target_audience_form.age.filter(i => i === 'all')">
                  {{ $t('base.all') }}
                </el-checkbox>
                <el-checkbox label="age__18_24"
                             @click.native="target_audience_form.age = target_audience_form.age.filter(i => i !== 'all')">
                  18-24
                </el-checkbox>
                <el-checkbox label="age__25_34"
                             @click.native="target_audience_form.age = target_audience_form.age.filter(i => i !== 'all')">
                  25-34
                </el-checkbox>
                <el-checkbox label="age__35_plus"
                             @click.native="target_audience_form.age = target_audience_form.age.filter(i => i !== 'all')">
                  35+
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <div style="display: flex">
            <div style="width: 140px">{{ $t('base.gender') }}</div>
            <div style="flex: 1; display: flex; gap: 5px">
              <el-radio v-model="target_audience_form.gender" label="all">{{ $t('base.all') }}</el-radio>
              <el-radio v-model="target_audience_form.gender" label="gender__men">{{ $t('base.men') }}</el-radio>
              <el-radio v-model="target_audience_form.gender" label="gender__women">{{ $t('base.women') }}</el-radio>
            </div>
          </div>
          <div style="display: flex">
            <div style="width: 140px">{{ $t('base.buyer_type') }}</div>
            <div style="flex: 1; display: flex; gap: 5px">
              <el-radio v-model="target_audience_form.buyer " label="all">{{ $t('base.all') }}</el-radio>
              <el-radio v-model="target_audience_form.buyer" label="buyer__new">{{
                  $t('base.potential_new_buyers')
                }}
              </el-radio>
            </div>
          </div>
        </div>

        <div style="margin-top: 30px" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check"
                     @click="m__update_target_audience">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="save_keyword_file.show" :close-on-click-modal="false" custom-class="no-body"
               width="400px">
      <div slot="title" style="padding:10px">
        <p class="text-title">{{ $t('base.filename') }}</p>
        <el-input size="mini" :placeholder="$t('input.filename')"
                  v-model="save_keyword_file.filename"></el-input>
        <div style="padding-top:20px;" class="text-right">
          <el-button size="mini" icon="el-icon-close" @click="save_keyword_file.show=false">{{
              $t('base.close')
            }}
          </el-button>
          <el-button size="mini" icon="ti-save" :loading="save_keyword_file.loading" type="primary"
                     @click="m__try_save_keyword_file"> &nbsp; {{ $t('base.save_file') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <input accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" type="file"
           @change="m__import_excel_file" id="input_control_create" style="display: none;">
  </div>
</template>

<script>
import {orderBy as _orderBy, drop as _drop, take as _take, uniqBy as _uniqBy} from 'lodash'
import readXlsxFile from 'read-excel-file'
import {ADS_CONSTANTS, make_uuid} from '../../../addon/ads_function'
import {fix_ads_mixins} from "../../../mixins/fix_ads";
import {package_mixins} from "../../../mixins/package";

export default {
  mixins: [fix_ads_mixins, package_mixins],

  props: {
    shop: {},
    sp_user: {},
    product_list: {},
    get_products: false,
    ads_config: {},
    ads_data: {},
    non_ads_data: {},
    selected_product_ids: null,
    cascader_options: null,
    fff: null,
    active_campaign_list: null
  },

  data() {
    return {
      campaign_info: {
        name: `Chiến Dịch Nhóm ${this.dayjs().format('MM/DD/YYYY')} - ${this.dayjs().unix()}`,
        budget_type: 'unlimited',
        daily_budget: 0,
        campaign_time: 'unlimited',
        campaign_date_range: [new Date(), new Date()],
        campaign_type: 'all',
        add_price_type: 'mipee',
        keyword_match_type: 'exact'
      },

      add_product_type: 'manual',
      config_campaign_price_type: 'auto',
      target_audience_type: 'auto',
      create_mode: 'single',

      product_filter: {
        page_size: 10,
        current_page: 0,
        keyword: '',
        total_record: 0,
        show: true,
        filter_type: 'all'
      },
      product_sort_option: {
        order: null,
        prop: null
      },

      product_selected_list: [],

      show_dialog: {
        select_product: false,
        update_keyword_price: false,
        shopee_result: false,
        update_target_audience: false
      },
      loading: {
        create_campaign: false,
        shopee_suggest_keywords: false,
        get_products: false
      },

      advertisements: [
        {
          extinfo: {
            target: {
              price: null,
              base_price: null,
              premium_rate: 0
            }
          },
          itemid: '',
          placement: 5,
          rate: 0,
          status: 1
        },
        {
          extinfo: {
            target: {
              price: null,
              base_price: null,
              premium_rate: 0
            }
          },
          itemid: '',
          placement: 2,
          rate: 0,
          status: 1
        },
      ],

      form_update_target_broad_roi: {
        type: 'auto',
        custom_type: 0,
        custom_type_list: [6.1 * 100000, 9.1 * 100000, 11 * 100000],
        custom_value: null
      },

      // todo: old create search campaign data
      fff_sort_option: {
        order: null,
        prop: null
      },
      keyword_file_list: [],
      keyword: '',
      selected_keyword_file: '',
      mipee_suggest_keywords: [],
      shopee_suggest_keywords: [],
      mipee_filter: {
        page_size: 10,
        current_page: 0,
        sort_option: {
          order: null,
          prop: null
        },
      },
      shopee_filter: {
        page_size: 10,
        current_page: 0,
        sort_option: {
          order: null,
          prop: null
        },
      },
      type_product: 'all',
      category_list: [],
      selected_category: null,
      shop_category_list: [],
      selected_shop_category: null,
      radio: '1',
      search_keyword: [],
      search_keyword_filter: {
        page_size: 10,
        current_page: 0,
        sort_option: {
          order: null,
          prop: null
        },
      },
      atosa_keyword_filter: {
        page_size: 10,
        current_page: 0
      },
      added_keyword: [],
      added_keyword_filter: {
        page_size: 10,
        current_page: 0
      },
      form_update_multiple_keyword_price: {
        update_type: 3,
        update_by_cost: 'increase',
        update_by_percent: 'increase',
        update_by_suggest_cost: 'increase',
        update_by_suggest_percent: 'increase',
        update_by_cost_value: 0,
        update_by_percent_value: 0,
        update_by_suggest_cost_value: 1,
        update_by_suggest_percent_value: 1,
        cost_value: 0,
        match_type: 1,
        price: 0
      },
      base_keyword: '',
      fff_loading: false,
      fff_profile: {},
      fff_show: true,
      fff_result: [],
      fetch_loading: false,
      fetch_keyword: '',
      fff_clone: [],
      save_keyword_file: {
        show: false,
        loading: false,
        filename: 'Tệp keyword'
      },
      excel_keyword_filter: {
        page_size: 10,
        current_page: 0
      },
      excel_keyword: [],
      save_and_result_list: [],
      omit_duplicated_keyword: false,

      MATCH_TYPE_0_MIN: null, // TODO: exact
      MATCH_TYPE_1_MIN: null, // TODO: broad
      TARGETING_MIN: null,
      DAILY_BUDGET_MIN: null,

      shopee_result: [],

      form_add_new_campaign: {
        price_type: 'shopee',
        match_type: 0
      },

      create_campaigns_result: [],

      target_audience_list: [
        {
          'group_id': 0,
          'group_name': 'Tệp đối tượng 1',
          'option_list': [
            {
              'option': 'age',
              'tag_list': null
            },
            {
              'option': 'gender',
              'tag_list': null
            },
            {
              'option': 'buyer',
              'tag_list': null
            }
          ],
          'premium_rate': 15
        }
      ],
      target_audience_form: {
        group_name: 'Tệp đối tượng 1',
        age: ['all'],
        gender: 'all',
        buyer: 'all'
      },

      enable_roi_two: true,
      roi_two_list: [],

      ecpc: false,

      cascader_value: 'all',
      cascader_type: null,
      cascader_id: null,
      cascader_result: [],

      create_separate_ads: false
    }
  },

  async beforeMount() {
    for (const product of this.product_list) {
      product.checked = false
    }

    if (this.selected_product_ids) {
      this.product_selected_list = this.product_list.filter(i => this.selected_product_ids.includes(i.id))
      this.m__get_shopee_suggest_keywords().catch(console.error)
    }

    await this.m__get_keyword_file()

    // todo: load item ads list
    let item_id_list = []
    for (let i = 0; i < this.product_list.length; i++) {
      item_id_list.push(this.product_list[i].id)

      if (item_id_list.length % 20 === 0) {
        await this.m__get_item_ads_list(item_id_list)
        item_id_list = []
      }
    }
    await this.m__get_item_ads_list(item_id_list)
    item_id_list = []

    // todo: set ads config
    if (this.ads_config && this.ads_config.bid_price) {
      this.MATCH_TYPE_0_MIN = this.m__calculate(this.ads_config.bid_price.search_product.exact_match.min / 100000)
      this.MATCH_TYPE_1_MIN = this.m__calculate(this.ads_config.bid_price.search_product.broad_match.min / 100000)
      this.TARGETING_MIN = this.m__calculate(this.ads_config.bid_price.targeting.min / 100000)
      this.advertisements[0].extinfo.target.price = this.TARGETING_MIN
      this.advertisements[0].extinfo.target.base_price = this.TARGETING_MIN
      this.advertisements[1].extinfo.target.price = this.TARGETING_MIN
      this.advertisements[1].extinfo.target.base_price = this.TARGETING_MIN
      this.DAILY_BUDGET_MIN = this.m__calculate(this.ads_config.ads_config.product_ads.manual.search_product.min_daily_budget / 100000)

      // console.log(this.MATCH_TYPE_0_MIN)
      // console.log(this.MATCH_TYPE_1_MIN)
    }

    this.form_update_target_broad_roi.type = this.ads_data && this.ads_data.ads_toggle.enable_simple_ads_roi2
      ? 0
      : 'custom'

    this.m__update_product_campaign_status()
  },

  watch: {
    'create_mode': function () {
      if (this.create_mode === 'group' && this.form_update_target_broad_roi.custom_type === 0) {
        this.form_update_target_broad_roi.custom_type = 'custom'
      }
    }
  },

  computed: {
    c__product_filter_list() {
      let result = this.product_list

      result = result.filter(i => !this.product_selected_list.some(ii => ii.id === i.id))

      if (this.cascader_value && this.cascader_value !== 'all' && this.cascader_type) {
        if (this.cascader_type === 'shopee') {
          result = result.filter(i => i.global_cat && this.array_to_set(i.global_cat.catid).has(this.cascader_id))
        }

        if (this.cascader_type === 'my_shop') {
          result = result.filter(i => this.array_to_set(this.cascader_result).has(i.itemid))
        }
      }

      if (this.product_filter.filter_type === 'ads_list_null') {
        result = result.filter(i => i.ads_list && !i.ads_list.length)
      }
      if (this.product_filter.filter_type === 'not_creating_roi_two_ads') {
        result = result.filter(i => i.ads_list && (i.ads_list.length && !i.ads_list.some(ii => ii.bidding_type === 'roi_two') || !i.ads_list.length))
      }
      if (this.product_filter.filter_type === 'not_creating_all_ads_auto') {
        result = result.filter(i => i.ads_list && (i.ads_list.length && !i.ads_list.some(ii => ii.type === 'all' && ii.bidding_type === 'auto')) || !i.ads_list.length)
      }
      if (this.product_filter.filter_type === 'not_creating_all_ads_manual') {
        result = result.filter(i => i.ads_list && (i.ads_list.length && !i.ads_list.some(ii => ii.type === 'all' && ii.bidding_type === 'manual')) || !i.ads_list.length)
      }
      if (this.product_filter.filter_type === 'not_creating_search_ads_auto') {
        result = result.filter(i => i.ads_list && (i.ads_list.length && !i.ads_list.some(ii => ii.type === 'keyword' && ii.bidding_type === 'auto')) || !i.ads_list.length)
      }
      if (this.product_filter.filter_type === 'not_creating_search_ads_manual') {
        result = result.filter(i => i.ads_list && (i.ads_list.length && !i.ads_list.some(ii => ii.type === 'keyword' && ii.bidding_type === 'manual')) || !i.ads_list.length)
      }
      if (this.product_filter.filter_type === 'not_creating_discover_ads_auto') {
        result = result.filter(i => i.ads_list && (i.ads_list.length && !i.ads_list.some(ii => ii.type === 'targeting' && ii.bidding_type === 'auto')) || !i.ads_list.length)
      }
      if (this.product_filter.filter_type === 'not_creating_discover_ads_manual') {
        result = result.filter(i => i.ads_list && (i.ads_list.length && !i.ads_list.some(ii => ii.type === 'targeting' && ii.bidding_type === 'manual')) || !i.ads_list.length)
      }

      if (this.product_sort_option.order) {
        this.product_sort_option.order === 'ascending' && (result = _orderBy(result, [this.product_sort_option.prop], ['asc']))
        this.product_sort_option.order === 'descending' && (result = _orderBy(result, [this.product_sort_option.prop], ['desc']))
      }

      const keyword = this.remove_unicode(this.product_filter.keyword)
      return result.filter(i => i.id.toString().includes(keyword) || this.remove_unicode(i.name.normalize()).includes(this.remove_unicode(keyword)))
    },

    c__product_display_list() {
      const limit = this.product_filter.page_size
      const skip = limit * (this.product_filter.current_page - 1)

      return _take(_drop(this.c__product_filter_list, skip), limit)
    },

    // todo: old create search campaign computed
    c__excel_keyword_display_list() {
      const limit = this.excel_keyword_filter.page_size
      const skip = limit * (this.excel_keyword_filter.current_page - 1)

      return _take(_drop(this.excel_keyword, skip), limit)
    },

    c__mipee_keywords_display_list() {
      let result = this.mipee_suggest_keywords

      if (this.mipee_filter.sort_option.order) {
        this.mipee_filter.sort_option.order === 'ascending' && (result = _orderBy(result, [this.mipee_filter.sort_option.prop], ['asc']))
        this.mipee_filter.sort_option.order === 'descending' && (result = _orderBy(result, [this.mipee_filter.sort_option.prop], ['desc']))
      }

      const limit = this.mipee_filter.page_size
      const skip = limit * (this.mipee_filter.current_page - 1)

      return _take(_drop(result, skip), limit)
    },

    c__shopee_keyword_display_list() {
      let result = this.shopee_suggest_keywords

      if (this.shopee_filter.sort_option.order) {
        this.shopee_filter.sort_option.order === 'ascending' && (result = _orderBy(result, [this.shopee_filter.sort_option.prop], ['asc']))
        this.shopee_filter.sort_option.order === 'descending' && (result = _orderBy(result, [this.shopee_filter.sort_option.prop], ['desc']))
      }

      const limit = this.shopee_filter.page_size
      const skip = limit * (this.shopee_filter.current_page - 1)

      return _take(_drop(result, skip), limit)
    },

    c__search_keyword_display_list() {
      let result = this.search_keyword

      if (this.search_keyword_filter.sort_option.order) {
        this.search_keyword_filter.sort_option.order === 'ascending' && (result = _orderBy(result, [this.search_keyword_filter.sort_option.prop], ['asc']))
        this.search_keyword_filter.sort_option.order === 'descending' && (result = _orderBy(result, [this.search_keyword_filter.sort_option.prop], ['desc']))
      }

      const limit = this.search_keyword_filter.page_size
      const skip = limit * (this.search_keyword_filter.current_page - 1)

      return _take(_drop(result, skip), limit)
    },

    c__added_keyword_display_list() {
      const limit = this.added_keyword_filter.page_size
      const skip = limit * (this.added_keyword_filter.current_page - 1)

      return _take(_drop(this.added_keyword, skip), limit)
    },

    c__fff_result_display_list() {
      const limit = this.atosa_keyword_filter.page_size
      const skip = limit * (this.atosa_keyword_filter.current_page - 1)

      let result = this.fff_result

      if (this.fff_sort_option.order) {
        this.fff_sort_option.order === 'ascending' && (result = _orderBy(result, [this.fff_sort_option.prop], ['asc']))
        this.fff_sort_option.order === 'descending' && (result = _orderBy(result, [this.fff_sort_option.prop], ['desc']))
      }

      return _take(_drop(result, skip), limit)
    }
  },

  methods: {
    m__update_product_campaign_status() {
      // console.log(this.active_campaign_list)
      for (const product of this.product_list) {
        product.ads_list = this.active_campaign_list.filter(i => i.itemid === product.id).map(i => ({
          type: i.type,
          bidding_type: i.bidding_type,
        }))
      }
    },

    async m__on_cascader_change(value) {
      this.loading.get_products = true

      this.cascader_type = value[0]
      this.cascader_id = value[value.length - 1]
      if (this.cascader_type === 'my_shop') {
        let offset = 0, limit = 100, product_ids = []
        let response = await this.sp_user.marketing_pas_get_products_with_category(offset, limit, 'my_shop', this.cascader_id)
        while (response && response.data && response.data.item_list && response.data.item_list.length) {
          product_ids.push(...response.data.item_list.map(i => i.itemid))
          offset += limit
          response = this.sp_user.marketing_pas_get_products_with_category(offset, limit, 'my_shop', this.cascader_id)
        }
        this.cascader_result = []
        this.cascader_result = product_ids
      }

      this.loading.get_products = false
    },

    async m__get_recommended_roi_two_target() {
      if (!this.product_selected_list.length) return

      const [product] = this.product_selected_list
      const response = await this.sp_user.marketing_pas_get_recommended_roi_two_target(product.itemid, make_uuid())
      if (response && response.data) {
        this.roi_two_list = []
        this.roi_two_list.push({
          percent: response.data.lower_bound.percentile,
          value: response.data.lower_bound.value / 100000
        })
        this.roi_two_list.push({
          percent: response.data.exact.percentile,
          value: response.data.exact.value / 100000
        })
        this.roi_two_list.push({
          percent: response.data.upper_bound.percentile,
          value: response.data.upper_bound.value / 100000
        })

        // this.form_update_target_broad_roi.custom_type = this.roi_two_list[0].value
      }
    },

    m__open_duplicate_link(item_id) {
      // const url = this.$route.path + `?shop_id=${this.shop.shop_id}&search=${this.parent_campaign.product.itemid}`
      const url = `/marketing/campaigns?shop_id=${this.shop.shop_id}&search=${item_id}`
      window.open(url, '_blank')
    },

    async m__get_item_ads_list(item_id_list) {
      if (!item_id_list || !item_id_list.length) return

      // const response = await this.sp_user.marketing_get_item_status(item_id_list)
      // if (response && response.data) {
      //   for (const item of response.data) {
      //     if (!item.ads_list.filter(i => ['ongoing'].includes(i.state)).length) continue
      //
      //     const found = this.product_list.find(i => i.id === item.itemid)
      //     if (found) found.ads_list = item.ads_list
      //   }
      // }
    },

    m__update_target_audience() {
      const [data] = this.target_audience_list
      if (!data) return

      const age = data.option_list.find(i => i.option === 'age')
      age.tag_list = JSON.stringify(this.target_audience_form.age) === JSON.stringify(['all'])
        ? null
        : this.target_audience_form.age.map(i => ({tag_name: i}))

      const gender = data.option_list.find(i => i.option === 'gender')
      gender.tag_list = this.target_audience_form.gender === 'all'
        ? null
        : [{tag_name: this.target_audience_form.gender}]

      const buyer = data.option_list.find(i => i.option === 'buyer')
      buyer.tag_list = this.target_audience_form.buyer === 'all'
        ? null
        : [{tag_name: this.target_audience_form.buyer}]

      this.show_dialog.update_target_audience = false
    },

    m__show_update_target_audience_dialog(data) {
      if (data) {
        this.target_audience_form.group_id = data.group_id
        this.target_audience_form.group_name = data.group_name

        const age = data.option_list.find(i => i.option === 'age')
        if (age) {
          if (age.tag_list && age.tag_list.length) {
            this.target_audience_form.age = age.tag_list.map(i => i.tag_name)
          } else {
            this.target_audience_form.age = ['all']
          }
        }

        const gender = data.option_list.find(i => i.option === 'gender')
        if (gender) {
          if (gender.tag_list && gender.tag_list.length) {
            this.target_audience_form.gender = gender.tag_list[0].tag_name
          } else {
            this.target_audience_form.gender = 'all'
          }
        }

        const buyer = data.option_list.find(i => i.option === 'buyer')
        if (buyer) {
          if (buyer.tag_list && buyer.tag_list.length) {
            this.target_audience_form.buyer = buyer.tag_list[0].tag_name
          } else {
            this.target_audience_form.buyer = 'all'
          }
        }
      }

      this.show_dialog.update_target_audience = true
    },

    m__map_audience_tag_id(tag_name) {
      if (tag_name === 'age__18_24') return 101001
      if (tag_name === 'age__25_34') return 101002
      if (tag_name === 'age__35_plus') return 101003
      if (tag_name === 'gender__men') return 102002
      if (tag_name === 'gender__women') return 102001
      if (tag_name === 'buyer__new') return 203001
    },

    m__map_audience_tag_name(data, key) {
      const found = data.option_list.find(i => i.option === key)
      if (!found) return ''

      if (!found.tag_list) return 'Tất cả'

      return found.tag_list.map(i => {
        if (i.tag_name === 'age__18_24') return '18-24'
        if (i.tag_name === 'age__25_34') return '25-34'
        if (i.tag_name === 'age__35_plus') return '35+'
        if (i.tag_name === 'gender__men') return this.$t('base.men')
        if (i.tag_name === 'gender__women') return this.$t('base.women')
        if (i.tag_name === 'buyer__new') return this.$t('base.potential_new_buyers')

        return i.tag_name
      }).join(',')
    },

    async m__confirm_create_new_product_campaign() {
      this.create_campaigns_result = []

      if (!this.product_selected_list.length) {
        this.ntf_w(this.$t('required.select_products_for_creating_ad'))
        return
      }

      if (this.campaign_info.campaign_time === 'daterange') {
        if (!this.campaign_info.campaign_date_range[0] || !this.campaign_info.campaign_date_range[1]) {
          this.ntf_w(this.$t('required.ad_duration'))
          return
        }
        if (this.dayjs(this.campaign_info.campaign_date_range[0]).isAfter(this.campaign_info.campaign_date_range[1])) {
          this.ntf_w(this.ntf_w(this.$t('base.y_gt_than_x', {
            y: this.$t('base.start_time'),
            x: this.$t('base.end_time'),
          })))
          return
        }
      }

      if (['all', 'search'].includes(this.campaign_info.campaign_type) && this.config_campaign_price_type === 'manual' && !this.added_keyword.length) {
        this.ntf_w(this.$t('required.must_select_at_least_keyword'))
        return
      }

      if (
        this.config_campaign_price_type === 'auto'
        && this.form_update_target_broad_roi.custom_type === 'custom'
        && this.form_update_target_broad_roi.custom_value === null
      ) {
        this.ntf_w('Vui lòng nhập Mục tiêu Roas')
        return
      }

      try {
        await this.$confirm(this.$t('ads.update_budget_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      this.loading.create_campaign = true
      try {
        if (this.create_mode === 'single') {
          for (const [index, product] of this.product_selected_list.entries()) {
            if (index > 1) await this.sleep(10000)

            const form = {
              reference_id: make_uuid(),
              campaign: {
                daily_budget: this.campaign_info.budget_type === 'unlimited' ? 0 : Math.round(+this.campaign_info.daily_budget * 100000),
                product_placement: this.campaign_info.campaign_type === 'search'
                  ? 'search_product'
                  : this.campaign_info.campaign_type,
                ecpc: this.ecpc,
                bidding_strategy: this.config_campaign_price_type,
                product_selection: this.add_product_type,
                start_time: this.campaign_info.campaign_time === 'unlimited'
                  ? this.dayjs().startOf('day').unix()
                  : this.dayjs(this.campaign_info.campaign_date_range[0]).startOf('day').unix(),
                end_time: this.campaign_info.campaign_time === 'unlimited'
                  ? 0
                  : this.dayjs(this.campaign_info.campaign_date_range[1]).endOf('day').unix()
              },
              ads_list: [
                {
                  item_id: product.itemid
                }
              ],
              header: {}
            }

            if (this.config_campaign_price_type === 'auto') {
              delete form.campaign.ecpc
              delete form.campaign.keyword_list
              delete form.campaign.display_location
              delete form.campaign.target_audience

              // todo: handle roi1
              if (this.non_ads_data && this.non_ads_data.ext_toggle && this.non_ads_data.ext_toggle.sz_ads_product_target_broad_roas) {
                form.campaign.bidding_strategy = 'auto'
                form.campaign.target_broad_roi = 0

                form.campaign.target_broad_roi = this.form_update_target_broad_roi.type === 'auto'
                  ? 0
                  : this.form_update_target_broad_roi.custom_type

                if (this.form_update_target_broad_roi.type === 'custom' && this.form_update_target_broad_roi.custom_type === 'custom') {
                  form.campaign.target_broad_roi = Math.round(+this.form_update_target_broad_roi.custom_value * 100000)
                  if (!form.campaign.target_broad_roi) form.campaign.target_broad_roi = 0
                }
              }

              // todo: handle roi2
              if (this.non_ads_data && this.non_ads_data.ext_toggle && this.non_ads_data.ext_toggle.sz_ads_roi2) {
                if (this.enable_roi_two) {
                  form.campaign.bidding_strategy = 'roi_two'
                  form.campaign.roi_two_target = Math.round(this.form_update_target_broad_roi.custom_type * 100000)
                  delete form.campaign.target_broad_roi

                  if (this.form_update_target_broad_roi.custom_type === 'custom') {
                    form.campaign.roi_two_target = +this.form_update_target_broad_roi.custom_value * 100000
                    if (!form.campaign.roi_two_target) form.campaign.roi_two_target = 0
                  }
                }
              }
            }
            if (['all', 'search'].includes(this.campaign_info.campaign_type) && this.config_campaign_price_type === 'manual') {
              form.campaign.keyword_list = this.added_keyword.map(keyword => {
                keyword.match_type = this.form_add_new_campaign.match_type
                keyword.price = this.m__calculate(keyword.recommend_price)
                this.m__prefix_keyword_price(keyword)

                return {
                  keyword: keyword.keyword.replace(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`]/g, '').trim().toLowerCase().normalize(),
                  bid_price: Math.round(keyword.price * 100000),
                  match_type: keyword.match_type === 0 ? 'exact' : 'broad'
                }
              })
              const MAX_LENGTH = ADS_CONSTANTS.MAX_KEYWORDS_LENGTH
              form.campaign.keyword_list = _uniqBy(form.campaign.keyword_list, 'keyword').slice(0, MAX_LENGTH)
            }
            if (['all', 'targeting'].includes(this.campaign_info.campaign_type) && this.config_campaign_price_type === 'manual') {
              form.campaign.display_location = {
                daily_discover: {
                  state: 'active',
                  bid_price: this.TARGETING_MIN
                },
                you_may_also_like: {
                  state: 'active',
                  bid_price: this.TARGETING_MIN
                }
              }
              const placement2 = this.advertisements.find(i => i.placement === 2)
              if (placement2) {
                const price = +placement2.extinfo.target.price && +placement2.extinfo.target.price > this.TARGETING_MIN ? +placement2.extinfo.target.price : this.TARGETING_MIN
                form.campaign.display_location.daily_discover.bid_price = Math.round(price * 100000)
              }
              const placement5 = this.advertisements.find(i => i.placement === 5)
              if (placement5) {
                const price = +placement5.extinfo.target.price && +placement5.extinfo.target.price > this.TARGETING_MIN ? +placement5.extinfo.target.price : this.TARGETING_MIN
                form.campaign.display_location.you_may_also_like.bid_price = Math.round(price * 100000)
              }
            }
            if (this.config_campaign_price_type === 'manual') {
              form.campaign.target_audience = {
                target_audience_type: this.target_audience_type,
                group_list: []
              }
              if (this.target_audience_type === 'manual') {
                const target_audience = this.clone(this.target_audience_list[0])
                target_audience.premium_rate *= 1000
                target_audience.option_list = target_audience.option_list.map(i => {
                  if (i.tag_list) {
                    i.tag_id_list = i.tag_list.map(ii => this.m__map_audience_tag_id(ii.tag_name))
                  }
                  return i
                })
                form.campaign.target_audience.group_list.push(target_audience)
              }
            }

            // todo: handle separate ads option
            if (form.campaign.product_placement === 'all' && form.campaign.bidding_strategy === 'manual' && this.create_separate_ads) {
              for (const type of ['targeting', 'search']) {
                const form_clone = this.clone(form)
                form_clone.reference_id = make_uuid()

                if (type === 'search') {
                  form_clone.campaign.product_placement = 'search_product'
                  delete form_clone.campaign.display_location
                }
                if (type === 'targeting') {
                  form_clone.campaign.product_placement = 'targeting'
                  delete form_clone.campaign.keyword_list
                }

                await this.sleep(1000)
                await this.m__handle_create_campaign(product, form_clone)
              }
            } else {
              await this.m__handle_create_campaign(product, form)
            }
          }
          this.show_dialog.shopee_result = true
        }

        if (this.create_mode === 'group') {
          const form = {
            reference_id: make_uuid(),
            campaign: {
              daily_budget: this.campaign_info.budget_type === 'unlimited' ? 0 : Math.round(+this.campaign_info.daily_budget * 100000),
              start_time: this.campaign_info.campaign_time === 'unlimited'
                ? this.dayjs().startOf('day').unix()
                : this.dayjs(this.campaign_info.campaign_date_range[0]).startOf('day').unix(),
              end_time: this.campaign_info.campaign_time === 'unlimited'
                ? 0
                : this.dayjs(this.campaign_info.campaign_date_range[1]).endOf('day').unix(),
              product_placement: 'all',
              name: this.campaign_info.name,
              bidding_strategy: 'roi_two',
              product_selection: 'manual_mpd',
              new_product_boost_toggle: false,
              roi_two_target: 0,
            },
            ads_list: this.product_selected_list.map(i => ({item_id: i.itemid}))
          }

          form.campaign.roi_two_target = Math.round(this.form_update_target_broad_roi.custom_type * 100000)
          delete form.campaign.target_broad_roi

          if (this.form_update_target_broad_roi.custom_type === 'custom') {
            form.campaign.roi_two_target = +this.form_update_target_broad_roi.custom_value * 100000
            if (!form.campaign.roi_two_target) form.campaign.roi_two_target = 0
          }

          const create_response = await this.sp_user.marketing_pas_publish_campaign(form)
          console.log('form', form)
          console.log('create_response', create_response)

          if (create_response && create_response.code === 0) {
            this.ntf_s('Tạo quảng cáo thành công')
          } else {
            let error_message = 'Đã có lỗi xảy ra'
            if (create_response && create_response.data && create_response.data.result_list && create_response.data.result_list.length) {
              const [item] = create_response.data.result_list
              error_message += ` - Mã lỗi: ${item.msg}`
            } else {
              error_message += JSON.stringify(create_response)
            }
            this.ntf_w(error_message)
          }
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      } finally {
        this.loading.create_campaign = false
      }
    },

    async m__handle_create_campaign(product, form,) {
      const create_response = await this.sp_user.marketing_pas_publish_campaign(form)
      console.log('form', form)
      console.log('create_response', create_response)
      if (create_response) {
        this.create_campaigns_result.push({
          ...product,
          code: create_response.code,
          message: create_response.msg,
          validation_error_list: create_response && create_response.data && create_response.data.result_list
            ? create_response.data.result_list.map(i => ({
              field: i.code,
              msg: i.msg
            }))
            : [{
              field: 'msg',
              msg: JSON.stringify(create_response)
            }]
        })

        // todo: update ads list
        if (create_response.code === 0) {
          product.ads_list = product.ads_list || []

          if (form.campaign.bidding_strategy === 'roi_two') {
            product.ads_list.push({
              type: 'all',
              bidding_type: 'roi_two',
            })
          }
          if (form.campaign.product_placement === 'search_product' && form.campaign.bidding_strategy === 'auto') {
            product.ads_list.push({
              type: 'keyword',
              bidding_type: 'auto',
            })
          }
          if (form.campaign.product_placement === 'search_product' && form.campaign.bidding_strategy === 'manual') {
            product.ads_list.push({
              type: 'keyword',
              bidding_type: 'manual',
            })
          }
          if (form.campaign.product_placement === 'targeting' && form.campaign.bidding_strategy === 'auto') {
            product.ads_list.push({
              type: 'targeting',
              bidding_type: 'auto',
            })
          }
          if (form.campaign.product_placement === 'targeting' && form.campaign.bidding_strategy === 'manual') {
            product.ads_list.push({
              type: 'targeting',
              bidding_type: 'manual',
            })
          }
        }
        // todo: end update ads list

        // todo: fix inactive placement
        if (create_response.code === 0 && create_response.data && create_response.data.result_list && this.advertisements.find(i => i.status !== 1)) {
          const [result] = create_response.data.result_list
          const campaign_id = result.campaign_id
          const inactive_placement = this.advertisements.find(i => i.status !== 1)

          let placement = ''
          if (inactive_placement.placement === 2) placement = 'daily_discover'
          if (inactive_placement.placement === 5) placement = 'you_may_also_like'
          const body = {
            campaign_id: campaign_id,
            type: 'change_display_location',
            header: {},
            change_display_location: {
              bid_price: Math.round(+inactive_placement.extinfo.target.price * 100000),
              place: placement,
              state: 'inactive'
            }
          }
          await this.sp_user.marketing_pas_update_campaign(body)
        }
        // todo: end fix inactive placement
      }
    },

    m__back_to_list() {
      this.$emit('back_to_list')
    },

    m__product_sort_change({
                             prop,
                             order
                           }) {
      this.product_sort_option.order = order
      this.product_sort_option.prop = prop
    },

    m__show_select_product_dialog() {
      this.show_dialog.select_product = true
    },

    m__confirm_select_product() {
      for (const product of this.product_list.filter(i => i.checked)) {
        if (this.product_selected_list.some(i => i.id === product.id)) continue
        this.product_selected_list.push(product)
      }
      this.show_dialog.select_product = false

      this.m__get_recommended_roi_two_target().catch(console.error)
      this.m__get_shopee_suggest_keywords().catch(console.error)
    },

    // todo: old create search campaign
    async m__get_keyword_file() {
      const response = await this.$http.get(this.API.marketing.keyword_file.list, this.cf())
      this.keyword_file_list = response.body.data
    },

    async m__import_excel_file(e) {
      try {
        const file_store = e.target.files || e.dataTransfer.files
        if (file_store.length === 0) {
          return
        }

        const raw = await readXlsxFile(file_store[0])
        for (const row of raw) {
          if (row && row[0] && typeof row[0] === 'string' && !this.excel_keyword.some(i => i.keyword === row[0].toLowerCase())) {
            this.excel_keyword.push({
              keyword: row[0].toLowerCase(),
              recommend_price: row[1] && !Number.isNaN(+row[1]) ? +row[1] : null,
              search_volume: 0,
              algorithm: 'kwrcmdv2',
              input_price: row[1] && !Number.isNaN(+row[1]) ? +row[1] : null
            })
          }
        }

        if (this.excel_keyword.length) {
          try {
            const resp = await this.$http.post(this.API.URL_API_SRV_2 + '/keyword/save_and_result', {
              mipeeUserId: this.$store.state.userInfo.username,
              keyword: this.excel_keyword[0].keyword,
              data: this.excel_keyword.map(i => i.keyword),
              country: this.sp_user.country
            }, this.cf())
            this.save_and_result_list = resp.body
          } catch (e) {
            console.error(e)
          }

          for (const keyword of this.excel_keyword) {
            if (keyword.recommend_price) continue

            const found = this.save_and_result_list.find(i => i.keyword === keyword.keyword)
            if (found) {
              keyword.search_volume = found.volume
              if (keyword.recommend_price === 0) keyword.recommend_price = this.m__calculate(found.recommendPrice)
            } else {
              const info = await this.sp_user.marketing_get_keyword_volume(keyword.keyword, this.product_list[0].id)
              keyword.search_volume = this.m__calculate(info.search_volume)
              keyword.algorithm = info.algorithm
              if (keyword.recommend_price === 0) keyword.recommend_price = this.m__calculate(info.recommend_price)
            }
          }
        }
      } catch (e) {
        console.log(e)
        this.ntf_w(this.$t('base.error_reading_file'))
      }
    },

    m__show_import_excel_file() {
      this.$el.querySelector(`#input_control_create`).click()
    },

    m__is_allow_keyword_tool() {
      const extent_package = this.$store.state.package.extend_package ? this.$store.state.package.extend_package.find(i => i.channel === 'shopee_marketing') : null
      if (extent_package) {
        return !!(this.dayjs().isBefore(this.dayjs(new Date(extent_package.license_to)), 's') &&
          extent_package.package.extra_data && extent_package.package.extra_data.marketing &&
          extent_package.package.extra_data.marketing.keyword_tool)
      } else {
        return false
      }
    },

    m__is_allow_delete_keyword() {
      const pack = this.$store.state.package && this.$store.state.package.extend_package && this.$store.state.package.extend_package.find(i => i.channel === 'shopee_marketing')
      return pack && pack.package && pack.package.extra_data && pack.package.extra_data.marketing && pack.package.extra_data.marketing.delete_keyword
    },

    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },

    m__add_all() {
      let source = []

      if (this.radio === '1') {
        source = this.shopee_suggest_keywords
      }
      if (this.radio === '2') {
        const data = JSON.parse(JSON.stringify(this.mipee_suggest_keywords))
        source = data.map(i => {
          i.recommend_price = this.form_add_new_campaign.price_type === 'mipee' ? i.price : i.recommend_price
          return i
        })
      }
      if (this.radio === '3') {
        source = this.search_keyword
      }
      if (this.radio === '4') {
        source = this.fff_result.slice(0, 100)
      }
      if (this.radio === '5') {
        source = this.excel_keyword
      }

      if (source) {
        console.log(source)
        for (let i = 0; i < source.length; i++) {
          if (this.omit_duplicated_keyword) {
            if (!this.added_keyword.find(e => e.keyword.normalize() === source[i].keyword.normalize())) {
              this.added_keyword.push({
                ...source[i],
                recommend_price: source[i].input_price || source[i].recommend_price || this.MATCH_TYPE_0_MIN
              })
            }
          } else {
            if (!this.added_keyword.find(e => e.keyword === source[i].keyword)) {
              this.added_keyword.push({
                ...source[i],
                recommend_price: source[i].input_price || source[i].recommend_price || this.MATCH_TYPE_0_MIN
              })
            }
          }
        }
      }
    },

    m__can_add(item) {
      return !this.added_keyword.find(i => i.keyword === item.keyword)
    },

    m__add_keyword(item, source) {
      if (source === 'shopee_suggest_keywords') {
        this.added_keyword.push({
          keyword: item.keyword,
          recommend_price: item.input_price || item.recommend_price || this.MATCH_TYPE_0_MIN,
          sp_volume: item.search_volume || item.sp_volume || 0
        })
      } else if (source === 'mipee_suggest_keywords') {
        this.added_keyword.push({
          keyword: item.keyword,
          recommend_price: item.input_price || item.recommend_price || this.MATCH_TYPE_0_MIN,
          sp_volume: item.search_volume || item.sp_volume || 0
        })
      } else if (source === 'search_shopee_keywords') {
        this.added_keyword.push({
          keyword: item.keyword,
          recommend_price: item.input_price || item.recommend_price || this.MATCH_TYPE_0_MIN,
          sp_volume: item.search_volume || item.sp_volume || 0
        })
      } else {
        this.added_keyword.push({
          ...item,
          recommend_price: item.input_price || item.recommend_price || this.MATCH_TYPE_0_MIN
        })
      }
    },

    m__remove_keyword(keyword) {
      this.added_keyword = this.added_keyword.filter(i => i.keyword !== keyword.keyword)
    },

    m__remove_product(index) {
      if (!this.product_selected_list.length || this.product_selected_list.length === 1) {
        return
      }

      this.product_selected_list.splice(index, 1)
    },

    async m__suggest_keyword(queryString, cb) {
      if (!queryString) {
        cb([])
        return
      }
      let hint_keywords = await this.sp_user.marketing_get_hint_keyword(queryString)
      cb(hint_keywords.map(e => ({value: e.keyword})))
    },

    async m__search_sp_keyword(keyword) {
      this.search_keyword = []

      if (!keyword.value) {
        return
      }

      let suggest_keywords_resp = await this.sp_user.marketing_suggest_keywords(keyword.value, this.product_list[0].id)
      while (!suggest_keywords_resp || !suggest_keywords_resp.data) {
        await this.sleep(2000)
        suggest_keywords_resp = await this.sp_user.marketing_suggest_keywords(keyword.value, this.product_list[0].id)
      }

      for (const item of suggest_keywords_resp.data) {
        this.search_keyword.push({
          ...item,
          checked: false,
          sp_volume: item.search_volume,
          sp_price: this.m__calculate(item.recommend_price)
        })
      }
    },

    async m__get_sp_keyword_info(keyword) {
      try {
        let info = await this.sp_user.marketing_get_keyword_volume(keyword.keyword, this.product_list[0].id)
        if (info !== null) {
          keyword.sp_volume = info.search_volume
          keyword.sp_price = keyword.recommend_price = this.m__calculate(info.recommend_price)
        }
      } catch (e) {
      }
    },

    m__prefix_keyword_price(keyword) {
      if (!keyword.price) keyword.price = 400

      if (keyword.match_type === 0 && keyword.price < this.MATCH_TYPE_0_MIN) {
        keyword.price = this.MATCH_TYPE_0_MIN
      }
      if (keyword.match_type === 1 && keyword.price < this.MATCH_TYPE_1_MIN) {
        keyword.price = this.MATCH_TYPE_1_MIN
      }
    },

    async m__get_keyword_file_detail() {
      if (!this.product_list.filter(i => i.checked).length) {
        this.selected_keyword_file = ''
        this.ntf_w(this.$t('required.must_select_at_least_product'))
        this.mipee_suggest_keywords = []
        return
      }

      const response = await this.$http.get(this.API.marketing.keyword_file.detail.replace('_id', this.selected_keyword_file), this.cf())
      for (const i of response.body.data.keyword_json) {
        i.search_volume = 0
        i.recommend_price = 0
      }
      this.mipee_suggest_keywords = response.body.data.keyword_json.map(i => {
        i.checked = true
        return i
      })

      for (const i of this.mipee_suggest_keywords) {
        await this.m__get_keyword_sp_info(i)
        await this.sleep(300)
      }
    },

    async m__get_keyword_sp_info(keyword) {
      if (this.product_list.filter(i => i.checked).length) {
        const temp_product = this.product_list.find(i => i.checked)
        try {
          let info = await this.sp_user.marketing_get_keyword_volume(keyword.keyword, temp_product.id)
          keyword.search_volume = info.search_volume
          keyword.recommend_price = this.m__calculate(info.recommend_price)
        } catch (error) {
          console.log(error)
        }
      }
    },

    async m__get_shopee_suggest_keywords() {
      if (!this.product_selected_list.length) return

      this.loading.shopee_suggest_keywords = true
      this.shopee_suggest_keywords = []
      const selected_products = this.product_selected_list
      for (const product of selected_products) {
        // const response = await this.sp_user.marketing_suggest_keyword(product.id)
        const response = await this.sp_user.marketing_pas_search_keyword('', product.id)
        if (response && response.data) {
          response.data.forEach(i => {
            i.recommend_price = this.m__calculate(i.recommend_price)
          })
          this.shopee_suggest_keywords.push(...response.data)
        }
      }
      this.shopee_suggest_keywords = _uniqBy(this.shopee_suggest_keywords, 'keyword')
      this.loading.shopee_suggest_keywords = false
    },

    m__remove_shopee_keyword(keyword) {
      const index = this.shopee_suggest_keywords.findIndex(i => keyword === keyword)
      this.shopee_suggest_keywords.splice(index, 1)
    },

    m__convert_category_children(children) {
      if (children && Array.isArray(children) && children.length) {
        for (const child of children) {
          child.value = child.category_id
          child.label = child.display_name
          if (child.children && Array.isArray(child.children) && child.children.length) {
            this.m__convert_category_children(child.children)
          }
        }
      }
    },

    m__show_update_keyword_dialog() {
      this.show_dialog.update_keyword_price = true
    },

    m__update_keyword_price() {
      if (this.form_update_multiple_keyword_price.update_type === 1 && this.form_update_multiple_keyword_price.update_by_cost_value) {
        this.added_keyword.forEach(i => {
          if (this.form_update_multiple_keyword_price.update_by_cost === 'increase') {
            i.recommend_price += this.m__calculate(this.form_update_multiple_keyword_price.update_by_cost_value)
          }

          if (this.form_update_multiple_keyword_price.update_by_cost === 'reduce') {
            i.recommend_price -= this.m__calculate(this.form_update_multiple_keyword_price.update_by_cost_value)
          }
        })
      }

      if (this.form_update_multiple_keyword_price.update_type === 2 && this.form_update_multiple_keyword_price.update_by_percent_value) {
        this.added_keyword.forEach(i => {
          if (this.form_update_multiple_keyword_price.update_by_percent === 'increase') {
            i.recommend_price += (i.recommend_price * this.m__calculate(this.form_update_multiple_keyword_price.update_by_percent_value) / 100)
          }

          if (this.form_update_multiple_keyword_price.update_by_percent === 'reduce') {
            i.recommend_price -= (i.recommend_price * this.m__calculate(this.form_update_multiple_keyword_price.update_by_percent_value) / 100)
          }
        })
      }

      if (this.form_update_multiple_keyword_price.update_type === 3) {
        this.added_keyword.forEach(i => {
          i.recommend_price = this.m__calculate(this.form_update_multiple_keyword_price.price)
        })
      }

      this.show_dialog.update_keyword_price = false
    },

    async m__enter_input() {
      if (!this.fff_loading) {
        await this.m__try_get_keyword_result()
      }
    },

    async m__try_get_keyword_result() {
      this.fff_loading = true
      let keyword_list = await this.m__get_suggestion_keyword(this.base_keyword)
      let result = await this.fff.get_keyword_result(keyword_list, 5000, this.base_keyword)
      if (result === null) {
        await this.$nextTick(() => {
          this.ntf_w(this.$t('keyword.error_while_get_data'))
        })
      } else if (!result.data || !result.data.keywords || !result.data.keywords.length || result.data.keywords.length < 30) {
        this.ntf_w(this.$t('keyword.result_not_found_message', {x: this.base_keyword}))
        await this.m__handle_missing_keyword(this.base_keyword)
      } else {
        let temp = result.data.keywords.map(e => {
          return {
            ...e,
            results: Math.round(e.results) || 0,
            checked: false,
            sp_volume: 0,
            loading: false,
            sp_price: 0
          }
        })
        if (!temp.some(i => i.keyword === this.base_keyword)) {
          const base_item = {
            keyword: this.base_keyword,
            results: 0,
            sp_volume: 0,
            sp_price: 0,
            relevance: 0,
            checked: false,
            loading: false
          }
          temp.unshift(base_item)
        }

        if (temp[0].keyword !== this.base_keyword) {
          const index = temp.findIndex(i => i.keyword === this.base_keyword)
          const temp_item = temp[index]
          temp.splice(index, 1)
          temp.unshift(temp_item)
        }

        const first = temp.shift()
        this.fff_result = _take(_orderBy(temp, ['results'], ['desc']), 500)
        this.fff_result.unshift(first)

        const keyword = this.base_keyword
        const extend_resp = await this.sp_user.marketing_suggest_keywords(keyword, this.product_list[0].itemid)
        if (extend_resp && extend_resp.data) {
          let index_splice = 1
          for (const item of extend_resp.data) {
            if (this.contain_at_least(keyword, item.keyword)) {
              const keyword = {
                keyword: item.keyword,
                results: 0,
                sp_volume: item.search_volume,
                sp_price: item.recommend_price,
                relevance: item.relevance,
                checked: false,
                loading: false
              }
              this.fff_result.splice(index_splice++, 0, keyword)
            }
          }
        }

        try {
          const resp = await this.$http.post(this.API.URL_API_SRV_2 + '/keyword/save_and_result', {
            mipeeUserId: this.$store.state.userInfo.username,
            keyword: this.base_keyword,
            data: this.fff_result.map(i => i.keyword),
            country: this.sp_user.country
          }, this.cf())
          this.save_and_result_list = resp.body
        } catch (e) {
          console.error(e)
        }

        for (const item of this.fff_result) {
          item.keyword = item.keyword.normalize()
        }
        this.result = _uniqBy(this.fff_result, 'keyword')

        this.fetch_index = 0
        this.fetch_keyword = this.base_keyword
        await this.m__start_get_sp_keyword()
      }

      this.fff_loading = false
    },

    async m__handle_missing_keyword(base_keyword) {
      const product_id = this.product_list[0].itemid
      const hint_keywords = await this.sp_user.marketing_list_keyword_hint(base_keyword, product_id, 0)
      if (hint_keywords && hint_keywords.data) {
        let index_splice = 2
        for (const hint of hint_keywords.data) {
          const extend_resp = await this.sp_user.marketing_suggest_keywords(hint.keyword, product_id)
          if (extend_resp && extend_resp.data) {
            for (const item of extend_resp.data) {
              if (!this.contain_at_least(base_keyword, item.keyword)) continue

              const keyword = {
                keyword: item.keyword,
                results: 0,
                sp_volume: +item.search_volume,
                sp_price: +item.recommend_price
              }
              if (!this.fff_result.some(i => i.keyword === item.keyword)) {
                this.fff_result.splice(index_splice++, 0, keyword)
              }
            }
          }
        }
      } else {
        const extend_resp = await this.sp_user.marketing_suggest_keywords(base_keyword, product_id)
        if (extend_resp && extend_resp.data) {
          let index_splice = 2
          for (const item of extend_resp.data) {
            if (!this.contain_at_least(base_keyword, item.keyword)) continue

            const keyword = {
              keyword: item.keyword,
              sp_volume: +item.search_volume,
              sp_price: +item.recommend_price
            }
            if (!this.fff_result.some(i => i.keyword === item.keyword)) {
              this.fff_result.splice(index_splice++, 0, keyword)
            }
          }
        }
      }

      if (this.fff_result.some(i => i.keyword === base_keyword) && this.fff_result[0].keyword !== base_keyword) {
        const index = this.fff_result.findIndex(i => i.keyword === base_keyword)
        const temp = this.fff_result[index]
        this.fff_result.splice(index, 1)
        this.fff_result.unshift(temp)
      }
      if (!this.fff_result.some(i => i.keyword === base_keyword)) {
        const response = await this.sp_user.marketing_suggest_keywords(base_keyword, product_id)
        if (response && response.data) {
          for (const item of response.data.reverse()) {
            if (!this.contain_at_least(base_keyword, item.keyword, false)) continue
            if (this.fff_result.some(i => i.keyword === item.keyword)) continue

            const keyword = {
              keyword: item.keyword,
              results: 0,
              sp_volume: item.search_volume,
              sp_price: item.recommend_price,
              relevance: item.relevance,
              checked: false,
              loading: false
            }
            this.fff_result.unshift(keyword)
          }
        }
      }
    },

    async m__start_get_sp_keyword() {
      this.fetch_loading = true

      for (const item of this.fff_result) {
        if (this.fetch_keyword !== this.base_keyword) {
          break
        }

        if (item.sp_volume && item.sp_price) continue

        const found = this.save_and_result_list.find(i => i.keyword === item.keyword)
        if (found) {
          item.relevance = found.relevance
          item.sp_volume = found.volume
          item.sp_price = item.recommend_price = this.m__calculate(found.recommendPrice)
        } else {
          await this.m__get_sp_keyword_info(item)
        }
      }

      this.fff_clone = JSON.parse(JSON.stringify(this.fff_result))
      this.fetch_loading = false
    },

    async m__get_suggestion_keyword(keyword) {
      const product_id = this.product_list[0] ? this.product_list[0].id : null
      const hint_keywords = await this.sp_user.marketing_list_keyword_hint(keyword, product_id, 0)
      return hint_keywords.data.map(i => i.keyword)
    },

    m__initial_save_keyword_file() {
      if (!this.m__is_allow_keyword_tool()) {
        this.ntf_w(this.$t('package.not_for_trial'))
        return
      }

      if (this.added_keyword.length > 0) {
        this.save_keyword_file.filename = `${this.$t('keyword.file')} ${this.added_keyword[0].keyword} (${this.added_keyword.length} ${this.$t('base.keyword')} - ${this.$t('base.at')} ${this.timeFormat(new Date())})`
        this.save_keyword_file.show = true
      } else {
        this.ntf_w(this.$t('keyword.empty_to_save'))
      }
    },

    m__try_save_keyword_file() {
      this.confirm(this.$t('keyword.confirm_save_file_x_name', {x: this.save_keyword_file.filename}), () => {
        this.save_keyword_file.loading = true

        this.$http.post(this.API.marketing.keyword_file.add, {
          filename: this.save_keyword_file.filename,
          keyword_json: this.added_keyword.map(i => {
            return {
              checked: true,
              keyword: i.keyword,
              keyword_source_type: 0,
              price: i.recommend_price,
              record_type: 0,
              rnum: 0,
              sp_price: i.recommend_price,
              sp_volume: i.sp_volume
            }
          })
        }, this.cf())
          .then(async (resp) => {
            this.ntf_s(resp)
            this.save_keyword_file.loading = false
            this.save_keyword_file.show = false

            this.$emit('m__reload_saved_keyword')
          })
          .catch(error => {
            console.log(error)
            this.ntf_w(error)
            this.save_keyword_file.loading = false
          })
      })
    },

    m__fff_sort_change({
                         prop,
                         order
                       }) {
      this.fff_sort_option.order = order
      this.fff_sort_option.prop = prop
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/pas/component/create_product.vue